if (!customElements.get('momo-password-countdown')) {
  customElements.define('momo-password-countdown', class extends HTMLElement {
    connectedCallback() {
      const target = Date.parse(this.dataset.target);
      const tick = () => {
        const remaining = Number.isFinite(target) ? Math.max(0, target - Date.now()) : 0;
        this.querySelector('[data-countdown]').hidden = remaining === 0;
        this.querySelector('[data-waiting]').hidden = remaining > 0;
        for (const [key, value] of Object.entries({days: Math.floor(remaining / 86400000), hours: Math.floor(remaining / 3600000) % 24, minutes: Math.floor(remaining / 60000) % 60})) {
          this.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0');
        }
        if (!remaining) clearInterval(this.timer);
      };
      this.timer = setInterval(tick, 1000);
      tick();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
